import DateTime from '@square/dashboard-data/models/squareup/common/time/date-time';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  averageTransactionFrequencyMillis: attr(Number),
  firstVisit: attr(DateTime),
  lastVisit: attr(DateTime),
  totalGpv: attr(MoneyProto),
  transactionCount: attr(Number)
});